export default __webpack_public_path__ + "static/media/chillrxgraph.png.webp";